import React, { useState, useEffect  } from 'react';
import NavLinks from '../navigation/NavLinks';
import { Link } from 'react-router-dom';
import SubscribeModal from '../common/SubscribeModal';
import ContactModal from '../common/ContactModal';
import { useLanguage } from "../common/LanguageContext";
import '../../styles/header.css';

function HeaderMobile({ isMenuOpen, setIsMenuOpen }) {
  const { switchLanguage, language } = useLanguage();
  const { translations } = useLanguage();
  const [isSubscribeOpen, setIsSubscribeOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Сбрасываем меню при изменении ширины экрана
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1524 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMenuOpen]);

  return (
    <>
      <header className="mobile-header">
        <div className="mobile-header-top">
          <div className="language-switch">
            <button
              className={`language-btn ${language === 'ru' ? 'active' : ''}`}
              onClick={() => switchLanguage('ru')}
            >
              RU
            </button>
            <button
              className={`language-btn ${language === 'en' ? 'active' : ''}`}
              onClick={() => switchLanguage('en')}
            >
              EN
            </button>
          </div>
          <Link key="MainMenu" to="/" className="mobile-header-logo">
            <img src="/NIRIVS_logo.svg" alt="NIRIVS Logo" className="logo-image" />
          </Link>
          <button className="burger-menu" onClick={toggleMenu}>
            <img
              src={isMenuOpen ? '/Burger_X.svg' : '/Burger.svg'}
              alt="Menu"
              className="burger-icon"
            />
          </button>
        </div>

        {isMenuOpen && (
          <nav className="mobile-menu">
            <NavLinks direction="column" closeMenu={closeMenu} />
            <div className='header-button-container'>
              <button className="header-button" onClick={() => { closeMenu(); setIsSubscribeOpen(true); }}>
                {translations.menuText.buttons.subscribeBtn}
              </button>
              <button className="header-button" onClick={() => { closeMenu(); setIsContactOpen(true); }}>
                {translations.menuText.buttons.msgUs}
              </button>
            </div>
          </nav>
        )}
      </header>
      {isSubscribeOpen && (
        <>
          <div className="overlay" onClick={() => setIsSubscribeOpen(false)}></div>
          <SubscribeModal onClose={() => setIsSubscribeOpen(false)} />
        </>
      )}
      {isContactOpen && (
        <>
          <div className="overlay" onClick={() => setIsContactOpen(false)}></div>
          <ContactModal onClose={() => setIsContactOpen(false)} />
        </>
      )}
    </>
  );
}

export default HeaderMobile;
